import useAppSelector from "utils/hooks/useAppSelector";


const useAuth = () => useAppSelector(state => state.auth);

export default useAuth;
